import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import BeeComponents from '@beetronix/bee-components'
import VueMeta from 'vue-meta'
import i18n from './i18n/i18n'
import { eStorage } from './plugins/eStorage'
import { eStorage as storage } from '@beetronix/estorage'
import VDeleteDialog from '@/components/VDeleteDialog.vue'
import ugarit from './plugins/ugarit'
import axios from './axios'
import VueApexCharts from 'vue-apexcharts'

Vue.config.productionTip = false

Vue.component('VDeleteDialog', VDeleteDialog);
Vue.use(BeeComponents);
Vue.use(ugarit);
Vue.use(VueMeta);
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

if (storage.l.has('auth')) {
	const auth = storage.l.get('auth');
	store.state.auth.self.token = auth.token;
	store.state.auth.self.username = auth.username;
	store.state.auth.self.roleId = auth.roleId;
	store.state.auth.self.userId = auth.userId;
	store.state.auth.isAuthorized = true;
	axios.defaults.headers.common.Authorization = `Bearer ${auth.token}`;
} else {
	router.replace({ name: 'login' })
}

new Vue({
	router,
	store,
	vuetify,
	eStorage,
	i18n,
	render: h => h(App)
}).$mount('#app')
